import IpsTelInput from './IpsTelInput.vue';
import '../../../styles/custom.scss';

export default IpsTelInput;
